import { render, staticRenderFns } from "./ListArchivedApplications.vue?vue&type=template&id=f3bd3fb0&scoped=true"
import script from "./ListArchivedApplications.vue?vue&type=script&lang=js"
export * from "./ListArchivedApplications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3bd3fb0",
  null
  
)

export default component.exports